export const mobileMenu = () => {
  const $toggle = $('.menu-toggle');
  const $header = $('#masthead');
  const supermenu = document.querySelector('.supermenu');
  const $supermenu = $(supermenu);

  // on click outside of menu, close menu
  const closeMenu = async () => {
    $toggle.removeClass('is-active');
    $header.removeClass('is-active');

    await supermenu.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 150,
    }).finished;

    $supermenu.removeClass('is-active');
  };

  $toggle.on('click', function (e) {
    e.stopPropagation();

    if ($toggle.hasClass('is-active')) {
      closeMenu();
    } else {
      $header.addClass('is-active');
      $toggle.addClass('is-active');
      $('.supermenu').addClass('is-active');
      // animate super menu in
      supermenu.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 150,
      });
    }
  });

  // copy menus into submenus
  const $servicesMenu = $('#services-menu .menu');
  const $surgeryMenu = $('#surgery-menu .menu');
  const $resourcesMenu = $('#resources-menu .menu');

  const $services = $('.supermenu .primary-menu a[href="#services"]');
  const $surgery = $('.supermenu .primary-menu a[href="#surgery"]');
  const $resources = $('.supermenu .primary-menu a[href="#resources"]');

  console.log($services);

  $services.parent().append($servicesMenu.clone());
  $surgery.parent().append($surgeryMenu.clone());
  $resources.parent().append($resourcesMenu.clone());

  function onClick(e) {
    e.preventDefault();
    e.stopPropagation();

    let isActive = $(this).parent().hasClass('is-active');

    // menu items
    $('.supermenu .menu-item').removeClass('is-active');
    $(this).parent().toggleClass('is-active', !isActive);
  }

  $services.on('click', onClick);
  $surgery.on('click', onClick);
  $resources.on('click', onClick);
};
